import SectionLabel from "../components/shared/SectionLabel";
import ExperienceTimeline from "../components/shared/ExperienceTimeline";
import StackTile from "../components/shared/StackTile";
import {
  SiRust,
  SiTypescript,
  SiPython,
  SiGo,
  SiNodedotjs,
  SiNextdotjs,
  SiReact,
  SiExpress,
  SiNestjs,
  SiSpring,
  SiFastapi,
  SiGraphql,
  SiGit,
  SiRedis,
  SiDocker,
  SiApachekafka,
  SiMongodb,
  SiAmazonaws,
  SiGooglecloud,
} from "react-icons/si";
import { experiences, education, certifications, skills } from "../data/experiences";

const skillIcons = {
  Rust: SiRust,
  TypeScript: SiTypescript,
  Python: SiPython,
  Golang: SiGo,
  "Node.js": SiNodedotjs,
  "Next.js": SiNextdotjs,
  "React.js": SiReact,
  "Express.js": SiExpress,
  "Nest.js": SiNestjs,
  "Spring Boot": SiSpring,
  FastAPI: SiFastapi,
  GraphQL: SiGraphql,
  Git: SiGit,
  Redis: SiRedis,
  Docker: SiDocker,
  Kafka: SiApachekafka,
  MongoDB: SiMongodb,
  AWS: SiAmazonaws,
  GCP: SiGooglecloud,
};

const Experience = () => {
  return (
    <div className="fade-up">
      <SectionLabel>experience</SectionLabel>
      <h1 className="text-3xl lg:text-4xl font-bold mb-12">
        Where I've built.
      </h1>

      <ExperienceTimeline experiences={experiences} />

      <div className="mt-16 border-t border-border pt-8">
        <SectionLabel>education</SectionLabel>
        <p className="text-white font-semibold">{education.degree}</p>
        <p className="text-sm text-muted mt-1">
          {education.school} · {education.duration}
        </p>
        <p className="text-sm text-muted mt-2 leading-relaxed max-w-xl">
          {education.coursework}
        </p>

        {certifications.length > 0 && (
          <div className="mt-6">
            {certifications.map((cert) => (
              <p key={cert.name} className="text-sm text-muted">
                <span className="text-white">{cert.name}</span> — {cert.issuer}
                , {cert.date}
              </p>
            ))}
          </div>
        )}
      </div>

      <div className="mt-16 border-t border-border pt-8">
        <SectionLabel>stack</SectionLabel>
        <div className="space-y-6">
          {Object.entries(skills).map(([group, items]) => (
            <div key={group}>
              <p className="text-xs font-mono text-muted mb-3">{group}</p>
              <div className="flex flex-wrap gap-3">
                {items.map((item) => (
                  <StackTile key={item} label={item} icon={skillIcons[item]} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Experience;
